import { defineStore } from "pinia";
import { local, session } from "@/utils/storage.js";

export const useStore = defineStore({
  id: "myGlobalState",
  state: () => ({
    parsedRoutes: [], //解析后的路由
  }),
  actions: {
    // 退出登录清除本地存储(清除部分)
    clearLocalStorage: () => {
      local.remove("access_token");
      local.remove("refresh_token");
      local.remove("id");
      local.remove("userName");
      local.remove("organizationName");
      local.remove("organizationId");
      local.remove("type");
      local.remove("breadcrumbData");
      local.remove("roles");
      session.remove("routes");
    },
  },
});
